module.exports = {"130531100":"广宗镇","130531101":"冯家寨镇","130531102":"北塘疃镇","130531103":"核桃园镇","130531200":"葫芦乡","130531201":"大平台乡","130531202":"件只乡","130531204":"东召乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130531.json
// module id = 231
// module chunks = 0